import ProductHeaderInterface from '../interfaces/ProductHeaderInterface';
import CartHeaderServices from '../Services/CartHeaderServices';

/**
 * Create Html element for product.
 */
export default class ProductTemplate {
  /*
   * Create Html element product
   * */
  public static createProductElement(
    productId: string,
    product: ProductHeaderInterface,
    template: HTMLElement | any,
    deleteCallback: Function
  ): Node | null {
    if (product) {
      const li: HTMLElement = template.content
        .cloneNode(true)
        .querySelector('.c-cartHeader__product');
      const links: NodeListOf<HTMLElement> = li.querySelectorAll('a');
      const title: HTMLElement = li.querySelector(
        '.c-cartHeader__product--title a'
      );
      const deleteProduct: HTMLElement = li.querySelector('.js-deleteProduct');
      const img: HTMLElement = li.querySelector(
        '.c-cartHeader__product--img a img'
      );
      const quantity: HTMLElement = li.querySelector(
        '.c-cartHeader__product--quantity span'
      );
      const price: HTMLElement = li.querySelector(
        '.c-cartHeader__product--price'
      );
      const reduced: HTMLElement = li.querySelector(
        '.c-cartHeader__product--reduced'
      );

      // Set id product
      li.dataset.product = productId;

      // Add links
      links.forEach((link) => {
        link.setAttribute('href', product.url);
      });

      // Add the product img
      img.classList.add('lazy');
      img.setAttribute(
        'src',
        "data:image/svg+xml;charset=utf-8,%3Csvg xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg' viewBox%3D'0 0 50 50'%2F%3E"
      );

      img.setAttribute('data-src', `${product.img}`);
      img.setAttribute('width', '50');
      img.setAttribute('height', '50');
      img.setAttribute('alt', product.titreProduit);

      // Add the product title
      title.textContent = product.titreProduit;

      // Add the product quantity
      quantity.textContent = product.qte.toString();

      // Add the product price
      price.innerHTML = `${product.formattedPrice}`;

      // Add the product reduced
      if (product.formattedBeforeDiscountPrice) {
        reduced.innerHTML = `${product.formattedBeforeDiscountPrice}`;
      }

      // Events Delete product
      deleteProduct.setAttribute('data-panier', product.idPanier.toString());
      deleteProduct.onclick = (event) => {
        event.stopPropagation();
        event.preventDefault();
        if (event.currentTarget instanceof HTMLElement) {
          const currentLink: HTMLElement = event.currentTarget;
          const productElement: HTMLElement = currentLink.closest(
            '.c-cartHeader__product'
          );
          const deleteReferenceId: string =
            currentLink.parentElement.parentElement.dataset.product;

          CartHeaderServices.deleteProduct(
            deleteReferenceId,
            deleteProduct,
            deleteCallback,
            productElement
          );
        }
      };

      return li;
    }
    return null;
  }
}
